import { Meeting } from "features/Resources/Meeting/models";
import { PrimaryButton } from "components/Button";
import { GroupSchedulingButtonBase, GroupSchedulingTableButton } from "./GroupSchedulingButton";
import { IndividualSchedulingButtonBase, IndividualSchedulingTableButton } from "./IndividualSchedulingButton";
import { useCallback } from "react";
import { MenuItem } from "@chakra-ui/react";
import { Text14 } from "components/Text";

interface SchedulingButtonProps {
  meeting?: Meeting;
}

export function SchedulingTableButton({ meeting }: SchedulingButtonProps) {
  if (!meeting) {
    return null;
  }
  return ["group_session_adhoc", "group_session_recurring"].includes(meeting.meetingType) ? (
    <GroupSchedulingTableButton meeting={meeting} />
  ) : (
    <IndividualSchedulingTableButton meeting={meeting} />
  );
}

export function SchedulingButton({ meeting, renderButton }: SchedulingButtonProps & { renderButton: (title: string, onOpen: () => void) => JSX.Element }) {
  if (!meeting || ["removed", "skipped", "cancelled"].includes(meeting?.status)) {
    return null;
  }

  const title = meeting.status === "pending_scheduling" ? "Schedule" : "Reschedule";

  if (["group_session_adhoc", "group_session_recurring"].includes(meeting.meetingType)) {
    return (
      <GroupSchedulingButtonBase
        renderButton={(onOpen) => renderButton(title, onOpen)}
        meetingId={meeting.id}
      />
    );
  }

  return (
    <IndividualSchedulingButtonBase
      renderButton={(onOpen) => renderButton(title, onOpen)}
      meetingId={meeting.id}
    />
  );
}

export function SchedulingShowButton({ meeting }: SchedulingButtonProps) {
  const renderButton = useCallback((title: string, onOpen: () => void) => (
    <PrimaryButton ml={2} size="2xs" onClick={onOpen}>{title}</PrimaryButton>
  ), []);

  return <SchedulingButton meeting={meeting} renderButton={renderButton} />;
}

export function SchedulingMenuButton({ meeting }: SchedulingButtonProps) {
  const renderButton = useCallback((title: string, onOpen: () => void) => (
    <MenuItem onClick={onOpen}>
      <Text14>{title}</Text14>
    </MenuItem >
  ), []);
  return <SchedulingButton meeting={meeting} renderButton={renderButton} />;
}
